module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ../node_modules/axios/index.js
// module id = 282
// module chunks = 0